:host {

  div.dialog {
    @apply w-full max-h-full;
    max-width: var(--vt-page-container-width, 1200px);
  }

  button.close {
    @apply text-grey absolute z-[2] bg-white rounded p-2 top-[5px] right-[5px];

    > svg {
      fill: none;
      stroke: currentColor;
      stroke-linecap:round;
      stroke-linejoin:round;
      stroke-width:2px;
      width: 26px;
      height: 26px;
    }
  }

  * {
    &::-webkit-scrollbar {
      width: 10px;
      left: -100px;
    }

    &::-webkit-scrollbar-track {
        background-color: var(--vt-color-grey-lighter, #EDEDEC);
        border-top-right-radius: .25rem;
        border-bottom-right-radius: .25rem;
        border-top-left-radius: .25rem;
        border-bottom-left-radius: .25rem;
    }

    &::-webkit-scrollbar-thumb {
        background-color: var(--vt-color-grey-light, #A5A5A2);
        border-radius: 8px;
        border: solid 2px transparent;
        background-clip: content-box;
    }

    scrollbar-color: var(--vt-color-grey-light, #A5A5A2);
    scrollbar-width: thin;
  }
}

:host(.lightbox) {
  div.dialog {
    @apply pt-6 px-5 pb-8;
  }

  button.close {
    @apply top-[50px] right-[45px];
  }
}

:host(.hotspot) {
  div.dialog {
    @apply border-b-[8px] border-b-yellow;
  }

  div.body {
    @apply overflow-x-hidden overflow-y-auto pt-6 px-5 pb-8;
  }
}

div.modal {
  @apply fixed inset-0 justify-center opacity-0 transition-opacity ease-linear hidden duration-300 z-[-1] py-[50px] md:px-[50px] px-[30px] overflow-hidden;

  &.backdrop {
    background-color: rgba(var(--vt-color-grey-dark-rgb, 20, 20, 18), 0.5);
  }

  &.open {
    @apply opacity-100;
  }

  &.flex {
    display: flex;
    align-items: center;
  }

}

div.dialog {
  @apply relative flex flex-col w-fit h-fit bg-white rounded translate-y-[-10%] transition-transform duration-300;
  max-width: calc(100% - 0.01px);

  &.open {
    @apply translate-y-0 border-b-[8px] border-b-yellow;
  }
}

.title {
  @apply grow text-s3 uppercase text-grey-light;
}

div.header {
  @apply flex-none border-b-2 border-b-yellow pb-3 mb-6;
}

div.body {
  @apply relative grow w-full overflow-hidden;
  &:hover {
    button {
      @apply opacity-100;
    }
  }
}

div.footer {
  @apply flex-none pt-6;
}
